module.exports = __webpack_public_path__ + "img/reach-connect.bb026b2f.jpg";